"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as i } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: r, size: c = 24 } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = n(), e = r !== null && r !== void 0 ? r : h ? o.colors.inverse : o.colors.neutralHigh, { skinName: t } = i();
    return t.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M21.241 12.571c.247.36.393.801.393 1.28 0 1.024-.672 1.887-1.581 2.143.096.256.155.53.155.82 0 1.024-.671 1.887-1.58 2.143.095.256.154.53.154.82C18.782 21 17.822 22 16.64 22h-6.07c-.854 0-1.713-.36-2.29-.958-.31-.322-.8-.521-1.279-.521H2.713a.73.73 0 0 1-.713-.74c0-.407.32-.739.713-.739H7c.855 0 1.714.36 2.29.957.31.323.8.522 1.28.522h6.069a.73.73 0 0 0 .713-.74c0-.407-.32-.739-.713-.739a.73.73 0 0 1-.713-.74c0-.407.32-.74.713-.74h1.426a.73.73 0 0 0 .713-.739c0-.407-.32-.74-.713-.74h-.357a.73.73 0 0 1-.713-.739c0-.407.32-.74.713-.74h1.787a.73.73 0 0 0 .713-.739c0-.407-.32-.74-.713-.74H18.07a.73.73 0 0 1-.713-.739c0-.407.32-.74.713-.74h1.787a.73.73 0 0 0 .713-.739c0-.407-.32-.74-.713-.74h-7.149a.73.73 0 0 1-.713-.739c0-.407.32-.74.713-.74h.435l.991-3.26V4.402c0-.512-.365-.924-.813-.924-.334 0-.718.175-.818.564l-.53 2.21a.75.75 0 0 1-.188.345l-3.866 4.01a2.08 2.08 0 0 1-1.513.65H2.713a.73.73 0 0 1-.713-.74c0-.407.32-.739.713-.739h3.693c.192 0 .37-.076.507-.218l3.725-3.863.49-2.025C11.387 2.668 12.27 2 13.33 2c1.234 0 2.24 1.08 2.24 2.408v1.11a.7.7 0 0 1-.033.222l-.89 2.925h5.21c1.179 0 2.143.996 2.143 2.223a2.26 2.26 0 0 1-.759 1.683"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M21.841 13.836c0-.605-.168-1.06-.38-1.392.21-.348.38-.832.383-1.502 0-1.53-1.18-2.283-2.384-2.347H16.05l-2.07-.062c.002-.826.005-2.356.005-3.613l.006-.132.003-.098c0-1.588-.936-2.535-2.499-2.535-.818 0-1.485.252-1.927.728-.294.32-.636.9-.569 1.849l.02.23.001.015c.008.076.016.148.018.245l.003.042c.025 1.112.04 2.516-.07 3.639-.117 1.232-1.336 1.994-1.885 2.274a1.44 1.44 0 0 0-.885-.308H3.609c-.801 0-1.454.653-1.454 1.457v7.596c0 .804.65 1.457 1.454 1.457h2.59c.34-.003.668-.123.928-.342l.06.015c.043.012.087.024.133.024l2.804.037c.16 0 .415.073.731.165l.208.059c.77.227 1.728.507 3.986.507 3.613 0 4.512-.33 5.075-1.857a.5.5 0 0 0 .031-.11c.076-.456.081-.848.011-1.195.737-.463 1.149-1.143 1.149-1.93 0-.49-.096-.874-.222-1.168.485-.485.748-1.093.748-1.748m-1.622-1.813a.62.62 0 0 0 .031.874q.363.337.364.939c0 .431-.224.804-.666 1.1a.63.63 0 0 0-.26.43.62.62 0 0 0 .142.478c.165.196.255.507.255.902 0 .563-.496.89-.91 1.062l-.056.028a.617.617 0 0 0-.247.834c.084.152.165.395.081.942-.246.663-.462.997-3.902.997-2.07 0-2.899-.242-3.627-.454l-.011-.003-.216-.062c-.409-.117-.734-.21-1.062-.21l-2.476-.033v-7.521q0-.013-.003-.024l-.002-.024v-.008c.759-.39 2.367-1.429 2.54-3.25.115-1.21.098-2.694.073-3.851a1 1 0 0 0-.005-.067c-.006-.092-.014-.17-.021-.249l-.002-.015-.017-.19q-.042-.62.244-.927c.258-.28.7-.336 1.028-.336.89 0 1.272.389 1.269 1.364l-.006.12v.034c0 1.823-.008 4.221-.008 4.221a.613.613 0 0 0 .596.62l2.684.078h3.392c.359.02 1.19.168 1.19 1.117 0 .474-.125.838-.358 1.05zM5.646 13.707c0-.448-.313-.762-.762-.762-.45 0-.762.31-.762.762 0 .448.314.762.762.762.449 0 .762-.314.762-.762m.555 6.44H3.609a.23.23 0 0 1-.227-.227v-7.594c0-.126.1-.23.227-.23h2.59c.121 0 .22.095.225.216v7.619a.225.225 0 0 1-.224.216"
        })
    }));
}, u = s;
export { u as default };
